import { Directive, HostBinding } from '@angular/core';

@Directive({
  selector: '[rkContainer]',
})
export class ContainerDirective {
  @HostBinding('style.background-color')
  get bg() {
    return 'white';
  }
  @HostBinding('style.border-radius')
  get br() {
    return '4px';
  }

  @HostBinding('style.box-shadow')
  get bs() {
    return '0 0 5px 0 rgba(177, 177, 177, 0.5)';
  }
}
